// Component: InfogramEmbed
// Author: Rahul A
import React from 'react';
import InfogramEmbedNPM from '@rotaryintl/app-infogram-embed';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const InfogramEmbed = (props) => {
  const smallScreenHeight = props.fields?.InfogramSmallScreenHeight?.value || 600;

  const largeScreenHeight = props.fields?.InfogramLargeScreenHeight?.value || 1000;

  return (
    <>
      <style>
        {`
          .rwc-infogram-embed .rwc-infogram-embed__iframe {
             height: var(--infogram-large-height) !important;
            min-height: 0 !important;
          }

          @media (max-width: 767px) {
            .rwc-infogram-embed .rwc-infogram-embed__iframe {
              height: var(--infogram-small-height) !important;
              min-height: 0 !important;
            }
          }

          .rwc-rich-text {
            margin-top: 20px !important;
          }
        `}
      </style>

      <div
        className="rwc-infogram-embed-wrapper"
        style={{
          '--infogram-large-height': `${largeScreenHeight}px`,
          '--infogram-small-height': `${smallScreenHeight}px`,
        }}
      >
        <InfogramEmbedNPM title={props.fields?.Title?.value} infogramID={props.fields?.InfogramID?.value} />
      </div>
    </>
  );
};

export default withSitecoreContext()(InfogramEmbed); 